import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Button } from 'antd-mobile-v5';
import { useHistory } from 'react-router-dom';
import { eproScaleUrl } from '../../../config/config';
import utils from '../../../utils/utils';

const ScaleQuantitative = (props: any) => {

    const history: any = useHistory();
    const [ recordId, seRecordId] = useState<any>(null);
    const [ scaleCode, setScaleCode] = useState<any>(null);

    useEffect(() => {
        initData();
    }, [])

    const initData = () => {
        const params = utils.getUrlParams();
        if (params.recordId) {
            seRecordId(params.recordId)
        }
        if (params.scaleCode) {
            setScaleCode(params.scaleCode)
        }
    }

    const goBack = () => {
        props.history.go(-1)
    }

    return (
        <div className={`${styles.epro_report_survey_container}`}>
            {
                recordId && scaleCode &&
                <iframe
                    src={`${eproScaleUrl}epro/evaluation/${scaleCode}?disabled=true&recordId=${recordId}`}
                    className={styles.iframe_container}
                    frameBorder="0"
                    height="100%"
                    width="100%"
                    id="pgwj"
                    title="评估问卷"
                ></iframe>
            }
            <div className={styles.iframe_btn_wrap}>
                <Button shape="rounded" color="default" className={styles.iframe_btn_back} onClick={goBack} >
                    返回
                </Button>
               
            </div>
          

        </div>
    )
}

export default ScaleQuantitative;